// Haptic Feedback Utility for Mobile Devices
export class HapticFeedback {
  constructor() {
    this.isSupported = 'vibrate' in navigator;
  }

  // Light vibration for button press
  light() {
    if (this.isSupported) {
      try {
        navigator.vibrate(50); // 50ms light vibration
      } catch (error) {
        console.warn('Vibration not supported:', error);
      }
    }
  }

  // Medium vibration for success actions
  medium() {
    if (this.isSupported) {
      try {
        navigator.vibrate(100); // 100ms medium vibration
      } catch (error) {
        console.warn('Vibration not supported:', error);
      }
    }
  }

  // Success pattern vibration
  success() {
    if (this.isSupported) {
      try {
        // Pattern: short-pause-short for success feeling
        navigator.vibrate([50, 50, 50]);
      } catch (error) {
        console.warn('Vibration not supported:', error);
      }
    }
  }

  // Add to cart specific vibration
  addToCart() {
    if (this.isSupported) {
      try {
        // Pattern: medium-short pause-light for cart action
        navigator.vibrate([80, 30, 40]);
      } catch (error) {
        console.warn('Vibration not supported:', error);
      }
    }
  }

  // Error vibration pattern
  error() {
    if (this.isSupported) {
      try {
        // Pattern: long vibration for error
        navigator.vibrate(200);
      } catch (error) {
        console.warn('Vibration not supported:', error);
      }
    }
  }
}

// Create singleton instance
export const hapticFeedback = new HapticFeedback();